<div class="access-denied-wrapper">
  <div class="access-denied">
    <img src="/assets/Images/access-denied.svg" />
    <p class="title">{{ 'Translation.Accessdenied' | translate }}</p>  
    <p class="sub-title">
      <span>{{'Translation.Accessdeniedmsg' | translate}}</span>
      <span>{{'Translation.Accessdeniedmsg1' | translate}}</span>
    </p>
  </div>
</div>
